































































import { Component, Watch, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { LanguageDto, ActivityDto, ActivityAreaDto } from "@/server/app.dtos";
import SideComponent from "@/models/shared/side.component";
import { LayoutServiceBus } from "@/services/bus/layout.service";
import { ActivitiesService } from "@/services/api/activities.service";
import {
  GetActivitiesDtosQuery,
  GetActivitiesDtosIncludeOptions,
  GetActivitiesDtosOrderOptions
} from "@/server/app.queries";
import { ListResponse } from "@/models/grids/list.response";
import ActivitiesMenuGlobal from "./shared/MenuGlobal.vue";
import ActivitiesMenuFilters from "./shared/MenuFilters.vue";
import ActivityTimelienEntry from "@/components/timelines/ActivityTimelineEntry.vue";
import SearchTimelienEntry from "@/components/timelines/SearchTimelineEntry.vue";

@Component({
  components: {
    SearchEntry: SearchTimelienEntry,
    Entry: ActivityTimelienEntry,
    LeftMenu: ActivitiesMenuGlobal,
    FiltersMenu: ActivitiesMenuFilters
  }
})
export default class ActivitiesListPage extends Vue {
  @Getter("currentLanguage") currentLanguage!: LanguageDto;
  @Getter("activityAreas") areas!: ActivityAreaDto[];
  @Watch("$route", { deep: true })
  onRouteChange() {
    this.Load();
  }
  isLoading: boolean = false;
  entries: ActivityDto[] = [];
  activitiesService: ActivitiesService = new ActivitiesService();

  async created() {
    await this.Load();
  }

  async Load() {
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    const request = new GetActivitiesDtosQuery();
    request.init(this.$route.query);
    request.includes = new GetActivitiesDtosIncludeOptions();
    request.includes.activityType = true;
    request.includes.activityArea = true;
    request.includes.activityStatus = true;
    request.includes.activityPriority = true;
    request.includes.assignees = true;
    request.orderBy = GetActivitiesDtosOrderOptions.DateStartDesc;
    request.take = 20;
    await this.activitiesService
      .GetList(request)
      .then((result: ListResponse<ActivityDto>) => (this.entries = result.data))
      .catch((error: any) => console.log(error))
      .finally(() => (this.isLoading = false));
  }

  viewActivity(activity: ActivityDto): void {
    const comp = new SideComponent();
    comp.title = "DetailActivitySideMenuComponent";
    comp.args = {
      activity: activity
    };
    LayoutServiceBus.openSideMenu(comp);
  }

  createActivity(area: ActivityAreaDto): void {
    const comp = new SideComponent();
    comp.title = "CreateActivitySideMenuComponent";
    comp.args = {
      activityArea: area
    };
    LayoutServiceBus.openSideMenu(comp);
  }
}
